module.exports = __webpack_public_path__ + "static/bitbucket-aa8dff66578cb18b985ff57a8c2acc80.svg";